import React from 'react'

const CTA = () => {
    return (
        <div className="cta">
        <a href="https://docs.google.com/document/d/1ugdBdMMbNJ07XWOFU7dSQ2TgSxUkOmvUVPB5w-NvoIE/export?format=pdf" className="btn">Downalod CV</a>
            <a href="#contact" className="btn btn-primary">Contact me</a>
        </div>
    )
}

export default CTA